// Diálogos in-app que reemplazan a window.confirm / window.prompt.
// Mismo patrón pub/sub que toast.js: los muestra <DialogoContainer /> (montado
// una vez en App) y cada llamada devuelve una promesa.
//
//   if (!(await dialogo.confirmar({ titulo: 'Eliminar', mensaje: '¿Seguro?', peligro: true }))) return;
//   const nombre = await dialogo.pedirTexto({ titulo: 'Nombre', placeholder: '…' });   // null si cancela

let listener = null;

function abrir(opciones) {
  return new Promise((resolve) => {
    // Sin contenedor montado (no debería pasar): el diálogo del navegador.
    if (!listener) {
      resolve(opciones.tipo === 'texto'
        ? window.prompt(opciones.mensaje || opciones.titulo, opciones.valorInicial || '')
        : window.confirm(opciones.mensaje || opciones.titulo));
      return;
    }
    listener({ ...opciones, resolve });
  });
}

const normalizar = (opts) => (typeof opts === 'string' ? { mensaje: opts } : opts);

const dialogo = {
  /** → true / false. Opciones: titulo, mensaje, textoAceptar, textoCancelar, peligro. */
  confirmar: (opts) => abrir({ tipo: 'confirmar', ...normalizar(opts) }),
  /** → texto (sin espacios a los costados) o null. Opciones: además, placeholder, valorInicial, maxLength. */
  pedirTexto: (opts) => abrir({ tipo: 'texto', ...normalizar(opts) }),
  subscribe: (fn) => {
    listener = fn;
    return () => { if (listener === fn) listener = null; };
  },
};

export default dialogo;
